import React from 'react';
import { ChevronDown } from 'lucide-react';
import { timezones } from '../constants/timezones';

interface TimezoneSelectorProps {
  value: string;
  onChange: (tz: string) => void;
  isOpen: boolean;
  onToggle: () => void;
  containerRef: React.RefObject<HTMLDivElement | null>;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({
  value,
  onChange,
  isOpen,
  onToggle,
  containerRef,
}) => (
  <div className="relative" ref={containerRef}>
    <label className="block text-sm font-medium text-gray-700 mb-1">Timezone</label>
    <button
      onClick={onToggle}
      className="w-full px-2 py-1 border rounded text-sm text-left flex items-center justify-between"
    >
      <span>{timezones.find((tz) => tz.value === value)?.label ?? value}</span>
      <ChevronDown className="w-3 h-3" />
    </button>

    {isOpen && (
      <div className="absolute top-full left-0 right-0 mt-1 bg-white border rounded shadow-lg max-h-40 overflow-y-auto z-10">
        {timezones.map((tz) => (
          <button
            key={tz.value}
            onClick={() => onChange(tz.value)}
            className={`w-full px-2 py-1 text-left text-sm hover:bg-gray-100 ${
              tz.value === value ? 'bg-blue-50 text-blue-600' : ''
            }`}
          >
            {tz.label}
          </button>
        ))}
      </div>
    )}
  </div>
);

export default TimezoneSelector;
